const getPdpUrl = (productSlug: string|undefined, variantSku: string|undefined, variantColour: string|undefined) => {
    productSlug = productSlug?.replace(/-[^-]+$/,'') ?? '';
    variantColour = variantColour?.replace(/[\s\\/]+/g, '-').toLowerCase() ?? '';
    if(variantColour)
        return `/product/${productSlug}-${variantColour}-${variantSku}/`;
    else
        return `/product/${productSlug}-${variantSku}/`;
}

const getPdpUrlWithLocale = (locale: string, productSlug:  string|undefined, variantSku:  string|undefined, variantColour:  string|undefined) => {
    return `/${locale}${getPdpUrl(productSlug, variantSku, variantColour)}`;
}

const isPdpUrl = (urlOrSlug: string) => {
    if (typeof urlOrSlug !== 'string') return false;
    const cleanUrl = urlOrSlug.split('?')[0]; // Remove query string
    return cleanUrl.indexOf('/product/') != -1 || cleanUrl.startsWith('product/');
}

/*
Handle all following string formats with or without trailing '/', wit or without a query string
https://specify.caroma.com/au/product/urbane-ii-hand-shower-chrome-105964/
/au/product/urbane-ii-hand-shower-chrome-105964/
au/product/urbane-ii-hand-shower-chrome-105964/
/product/urbane-ii-hand-shower-chrome-105964/
product/urbane-ii-hand-shower-chrome-105964/
*/
const getSkuFromUrlOrSlug = (urlOrSlug: string): string | undefined =>  {
    if (typeof urlOrSlug !== 'string') return undefined;
    const cleanString = urlOrSlug.split('?')[0].replace(/\/$/, '');
    return cleanString.split('-').pop();
  }

export { isPdpUrl, getPdpUrl, getPdpUrlWithLocale,  getSkuFromUrlOrSlug };
